import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appExchangeRatePermission]'
})
export class ExchangeRatePermissionDirective {

  constructor(private elementRef: ElementRef) {

  }

  ngOnInit() {
    //TODO
    // if (this.permissionService.checkPermissionsForSection('exchange_rates', 4) === false) {
    //   this.elementRef.nativeElement.setAttribute('readonly', 'true');
    // }
  }

}
